import { render, staticRenderFns } from "./IntegrationsLogs.vue?vue&type=template&id=8aad8f24&"
import script from "./IntegrationsLogs.vue?vue&type=script&lang=js&"
export * from "./IntegrationsLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports